import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=1050e1b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1050e1b4"]])

export default __exports__